module.exports = __webpack_public_path__ + "img/oval_bg@2x.d8743cbd.png";